import { Button, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, Text, useFocusableGroup } from '@fluentui/react-components';
import { ArchiveRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { FlexBox } from '../../shared-components/flex-box';
import './ProgramsTable.scss';

const ProgramsTableImpl: React.FC = () => {
  const {
    programsPageUiStore,
  } = useStores();

  const focusableGroupAttr = useFocusableGroup({
    tabBehavior: 'limited-trap-focus',
  });

  const handleArchiveProgram = (programId: number): void => {
    programsPageUiStore.setProgramIdToArchive(programId);
  };

  return (
    <FlexBox className='programs-table'>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderCell className='col-program'>Program</TableHeaderCell>
            <TableHeaderCell>Owner</TableHeaderCell>
            <TableHeaderCell>Archived</TableHeaderCell>
            <TableHeaderCell className='col-actions' />
          </TableRow>
        </TableHeader>
        <TableBody>
          {
            programsPageUiStore.programs
              .slice()
              .sort((programA, programB) => +programB.status - +programA.status)
              .map((program) => {
                return (
                  <TableRow
                    key={program.programId}
                  >
                    <TableCell className='col-program'>
                      {program.displayName}
                    </TableCell>
                    <TableCell>
                      {program.owner}
                    </TableCell>
                    <TableCell>
                      {
                        program.status ? 'No' : 'Yes'
                      }
                    </TableCell>
                    <TableCell
                      tabIndex={0}
                      className='col-actions'
                      {...focusableGroupAttr}
                    >
                      {
                        program.status &&
                        <Button
                          appearance='transparent'
                          as='button'
                          onClick={() => handleArchiveProgram(program.programId)}
                          icon={<ArchiveRegular />}
                        >
                          Archive
                        </Button>
                      }
                    </TableCell>
                  </TableRow>
                )
              })
          }
          {
            programsPageUiStore.hasNoPrograms &&
            <TableRow>
              <TableCell colSpan={4}>
                <Text
                  block
                  italic
                  align='center'
                >
                  No Program
                </Text>
              </TableCell>
            </TableRow>
          }
        </TableBody>
      </Table>
    </FlexBox>
  );
};

export const ProgramsTable = observer(ProgramsTableImpl);
